(function(){
    angular
        .module('app')
        .directive('ngSelect2model', select2model);

        select2model.$inject = ['$timeout'];
        function select2model($timeout){
            return {
              require: 'ngModel',
              scope:{
                extras: "=",
                control: "="
              },
            link: function (scope, element, $attrs, ngModel) {
                return $timeout(function () {
                  var valorrel = "";
                    /*if(typeof(scope.control) != 'undefined'){
                      if(typeof(scope.control.camposActual["_campo_"+$attrs["camporel"]])!='undefined'){
                        valorrel = scope.control.camposActual["_campo_"+$attrs["camporel"]];
                      }
                    }*/
                    var value = $attrs.value;
                    var $element = $(element);
                    var name = $element.attr("id");
                    var valuesArray = [];
                    //console.log($attrs.value);
                    function format(icon) {
                        var originalOption = icon.element;
                          var str = "";
                          if(typeof $(originalOption).data('icon') != 'undefined'){
                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
                            return $(str+" ");
                          }else{
                            return icon.text || icon.value;
                          }
                      }
                    if(typeof $attrs.multiple!='undefined'){
                      if(typeof $attrs.value!="undefined"){
                        valuesArray = $attrs.value.split(",");
                      }
                      if($attrs.campos!=''){
                        $element.select2({ ajax: {
                              url: "/backend/altcrm/content/select2model",
                              dataType: 'json',
                              delay: 250,
                              data: function (params) {
                                return {
                                  q: params.term, // search term
                                  page: params.page,
                                  model: $attrs.modelname,
                                  field: $attrs.campos,
                                  fieldval: $attrs.fieldval,
                                  per_page: 20,
                                  nodetype:$attrs.nodetype
                                };
                              },
                              processResults: function (data, params) {
                                // parse the results into the format expected by Select2
                                // since we are using custom formatting functions we do not need to
                                // alter the remote JSON data, except to indicate that infinite
                                // scrolling can be used
                                params.page = params.page || 1;
                                return {
                                  results: data.items,
                                  pagination: {
                                    more: (params.page * 1) < data.total_count
                                  }
                                };
                              },
                              cache: true
                            },templateSelection: format,
                            templateResult: format}).val(valuesArray).trigger("change");
                      }else{
                        $element.select2({ templateSelection: format,
                            templateResult: format}).val(valuesArray).trigger("change");
                      }
                      
                      $element.on("select2:select", function (evt) {
                        var elementVar = evt.params.data.element;
                        var $elementVar = $(elementVar);
                        
                        $elementVar.detach();
                        $(this).append($elementVar);
                        //$(this).trigger("change");
                      });
                      scope.$watch('extras', function(newValue, oldValue) {
                        var valorElemento = $element.val();
                        $timeout(function(){
                          $element.trigger("change");
                        })
                      }, true);
                     

                      if(valuesArray.length>0){
                        var ids = $attrs.value.split(",").reverse();
                        //console.log("ENTOOOOOO");
                        for(var cont=0;cont<ids.length;cont++){
                          var id = ids[cont];
                          var option = $element.find('option[value="' + id + '"]')[0];
                          $($element).prepend(option);
                        }
                        $element.trigger("change");
                      }
                      //$element.trigger("change");
                      var ul = $element.parent().find("ul.select2-selection__rendered");
                      ul.sortable({
                          placeholder : 'ui-state-highlight',
                          items: '> li.select2-selection__choice',
                          tolerance   : 'pointer',
                          stop: function() {
                              $(ul.find('.select2-selection__choice').get().reverse()).each(function() { 
                                  var id = $(this).data('data').id;
                                  var option = $element.find('option[value="' + id + '"]')[0];
                                  $($element).prepend(option);
                                  //$element.trigger("change");
                              });
                              $element.trigger("change");
                          }
                      });
                    }else{
                      if($attrs.campos!=''){
                        
                        $element.select2({
                          ajax: {
                            url: "/backend/altcrm/content/select2model",
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                              return {
                                q: params.term, // search term
                                page: params.page,
                                model: $attrs.modelname,
                                field: $attrs.campos,
                                fieldval: $attrs.fieldval,
                                per_page: 20,
                                nodetype:$attrs.nodetype
                              };
                            },
                            processResults: function (data, params) {
                              // parse the results into the format expected by Select2
                              // since we are using custom formatting functions we do not need to
                              // alter the remote JSON data, except to indicate that infinite
                              // scrolling can be used
                              params.page = params.page || 1;
                              return {
                                results: data.items,
                                pagination: {
                                  more: (params.page * 1) < data.total_count
                                }
                              };
                            },
                            cache: true
                          },
                          templateSelection: format,
                          templateResult: format
                        });
                      }else{
                        
                        $element.select2({
                          templateSelection: format,
                          templateResult: format
                        });
                      }

                    }
                });
            }
          }
      }
})();